import { Controller } from "@hotwired/stimulus"

// INTENT: Dynamically toggle appearance="filled-outlined" vs appearance="outlined" on wa-card tiles when role radio option changes.
// EXPECTED OUTCOME: Gives the active role card tile a native Web Awesome filled surface background and makes the entire card tile clickable.
// CAVEAT/TRAP: Listen for wa-change events on wa-radio-group and click events on cards to delegate selection to inner wa-radio.
export default class extends Controller {
  static targets = ["card", "radioGroup"]

  connect() {
    this.updateSelected()
  }

  cardTargetConnected(card) {
    card.addEventListener("click", this.handleCardClick)
  }

  cardTargetDisconnected(card) {
    card.removeEventListener("click", this.handleCardClick)
  }

  handleCardClick = (event) => {
    // INTENT: If user clicked the card padding or container outside wa-radio, forward click to inner wa-radio.
    // EXPECTED OUTCOME: Makes the entire card tile (including padding) responsive to clicks.
    // CAVEAT/TRAP: Avoid calling click() if event target is already inside wa-radio to prevent double-firing.
    const card = event.currentTarget
    const radio = card.querySelector("wa-radio")
    if (radio && !event.target.closest("wa-radio")) {
      radio.click()
    }
  }

  updateSelected() {
    // // INTENT: Retrieve selected value from radio group target, falling back to value attribute if custom element property is not yet upgraded.
    // // EXPECTED OUTCOME: Accurately matches selected role card even prior to custom element lifecycle hydration.
    // // CAVEAT/TRAP: Check both .value property and getAttribute('value') for compatibility across jsdom and real browsers.
    const selectedValue = this.hasRadioGroupTarget ? (this.radioGroupTarget.value || this.radioGroupTarget.getAttribute("value")) : null

    this.cardTargets.forEach((card) => {
      const radio = card.querySelector("wa-radio")
      const radioVal = radio ? (radio.value || radio.getAttribute("value")) : null
      if (radio && radioVal === selectedValue) {
        card.setAttribute("appearance", "filled-outlined")
      } else {
        card.setAttribute("appearance", "outlined")
      }
    })
  }

  select() {
    this.updateSelected()
  }
}
